import { Card, Tag } from "antd"
import "./DevicePanelCard.scss"

export const panelStatusColor = (tone = "default") =>
  tone === "ok"
    ? "green"
    : tone === "bad"
      ? "red"
      : tone === "warn"
        ? "gold"
        : tone === "info"
          ? "blue"
          : "default"

export const PanelStatusTag = ({ label, tone = "default" }) => (
  <Tag color={panelStatusColor(tone)}>{label}</Tag>
)

const DevicePanelCard = ({
  title,
  description,
  icon,
  iconTone,
  status,
  extra,
  children,
  loading,
  danger,
  className = "",
}) => (
  <Card
    loading={loading}
    className={`ds-card ${danger ? "ds-card--danger" : ""} ${className}`.trim()}
    title={
      <div className="ds-card__title">
        {icon ? (
          <span
            className={`ds-card__icon${
              iconTone === "danger"
                ? " ds-card__icon--danger"
                : iconTone === "ok"
                  ? " ds-card__icon--ok"
                  : iconTone === "warn"
                    ? " ds-card__icon--warn"
                    : ""
            }`}
          >
            {icon}
          </span>
        ) : null}
        <div className="ds-card__heading">
          <div className="ds-card__name">{title}</div>
          {description ? <p className="ds-card__desc">{description}</p> : null}
        </div>
      </div>
    }
    extra={
      status || extra ? (
        <div className="ds-status-row">
          {status || null}
          {extra || null}
        </div>
      ) : null
    }
  >
    {children}
  </Card>
)

export default DevicePanelCard
